module.exports = __webpack_public_path__ + "static/media/piscina.65b049f8.jpg";